import { CHANNEL_RECORD_FILTER, LISTING_STATUS } from '../constants/listingStatus';

export { CHANNEL_RECORD_FILTER };

const DRAFT_FILTERS = new Set([
  CHANNEL_RECORD_FILTER.HAS_DRAFT,
  CHANNEL_RECORD_FILTER.DRAFT_ONLY,
  LISTING_STATUS.DRAFT,
]);

const PUBLISHED_FILTERS = new Set([
  CHANNEL_RECORD_FILTER.HAS_PUBLISHED,
  CHANNEL_RECORD_FILTER.PUBLISHED_ONLY,
  LISTING_STATUS.PUBLISHED,
]);

const hasText = (value) => typeof value === 'string' && value.trim() !== '';

export const listingHasDraft = (item) => (
  (item?.listingStatus || '').toUpperCase() === LISTING_STATUS.DRAFT
);

export const listingHasPublished = (item) => {
  const status = (item?.listingStatus || '').toUpperCase();
  if (status === LISTING_STATUS.PUBLISHED) return true;
  const live = item?.live;
  if (!live) return false;
  return hasText(live.title) || Boolean(live.storeId) || Boolean(live.status);
};

const textHits = (value, query) => {
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return false;
  return String(value || '').toLowerCase().includes(needle);
};

export const resolveActiveRecordVersion = (item, recordFilter, searchText) => {
  const filter = String(recordFilter || '').trim().toUpperCase();
  if (DRAFT_FILTERS.has(filter)) return 'draft';
  if (PUBLISHED_FILTERS.has(filter)) return 'published';

  const draftTitle = item?.title || item?.listingProduct?.title || '';
  const liveTitle = item?.live?.title || '';
  if (textHits(liveTitle, searchText) && !textHits(draftTitle, searchText) && listingHasPublished(item)) {
    return 'published';
  }

  if (listingHasDraft(item)) return 'draft';
  return 'published';
};
